export default __webpack_public_path__ + "static/media/bike.aab2d9f6.svg";